import type { Contract } from "@/mocks/defineContract"

/**
 * Auto-discovers every contract in ./contracts. Adding a contract file is
 * enough to register it — there is nothing to generate and no list to maintain.
 *
 * `import.meta.glob` is resolved by Vite at build time, so this costs nothing at
 * runtime and is tree-shaken out of production along with mockFetch.
 */
const modules = import.meta.glob<{ contract: Contract<unknown> }>("./contracts/*.contract.ts", { eager: true })

export const mockRegistry: Record<string, Contract<unknown>> = Object.fromEntries(
  Object.values(modules)
    .filter((module) => module.contract?.status === "mocked")
    .map((module) => [module.contract.operation, module.contract])
)
